import { httpClient } from "@coworker/http-client";
import { TaskLink, TaskLinks } from "../types/taskLink";

export const insertTaskLink = async (taskLink: TaskLink) => {
  try {
    const data = await httpClient.roomsettings.post<{ id: string }>("/tasks", {
      body: taskLink,
    });
    return data.id;
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return null;
};

export const getTaskLinksByMedia = async (mediaId: string) => {
  try {
    const data = await httpClient.roomsettings.get<{ taskLinks: TaskLinks }>(
      `/tasks/medias/${mediaId}`
    );
    return data.taskLinks;
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return null;
};

export const getTaskLinksByStore = async (storeId: string) => {
  try {
    return await httpClient.roomsettings.get<TaskLinks>(
      `/tasks/stores/${encodeURIComponent(storeId)}`
    );
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return null;
};

export const getTaskLinksByArticle = async (
  storeId: string,
  productArticleId: string
) => {
  try {
    return await httpClient.roomsettings.get<TaskLinks>(
      `/tasks/stores/${encodeURIComponent(storeId)}/articles/${productArticleId}`
    );
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return null;
};

export const deleteTaskLinks = async (taskIds: string[]) => {
  try {
    return await httpClient.roomsettings.delete<TaskLinks>(
      `/tasks?ids=${taskIds.join(",")}`
    );
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return null;
};
